<template>
    <ui-FormSelect
        v-if="type === 'select'"
        :label="label"
        :isError="hasError(data.errors[property])"
        :feedback="data.errors[property]"
        v-model="data.model[property]"
        :options="options"
        v-on="$listeners"
        v-bind="$attrs"
    ></ui-FormSelect>
    <ui-FormCheckBox
        v-else-if="type === 'checkbox'"
        :label="label"
        :isError="hasError(data.errors[property])"
        :feedback="data.errors[property]"
        :trueValue="trueValue"
        :falseValue="falseValue"
        v-model="data.model[property]"
        v-on="$listeners"
        v-bind="$attrs"
    ></ui-FormCheckBox>
    <ui-FormInput
        v-else
        :label="label"
        :isError="hasError(data.errors[property])"
        :feedback="data.errors[property]"
        :type="type"
        :placeholder="placeholder"
        v-model="data.model[property]"
        v-on="$listeners"
        v-bind="$attrs"
    ></ui-FormInput>
</template>

<script>
    export default {
        name: 'FormMixinInput',
        inject: ['formData'],
        props: {
            data: {
                default() {
                    return this.formData;
                },
            },
            label: String,
            type: String,
            property: String,
            placeholder: String,
            options: null,
            trueValue: {
                default: true,
            },
            falseValue: {
                default: false,
            },
        },
        methods: {
            hasError: function(error) {
                return error ? true : false;
            },
        },
    };
</script>
